import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

const landscapeLayer1 = [
  [31, 22, 26, 22, 31],
  [23, 31, 31, 22, 23],
  [23, 23, 23, 22, 31],
  [23, 31, 31, 26, 31],
  [23, 22, 22, 22, 23],
];
const landscapeLayer2 = [
  [0, 1, 13, 0, 0],
  [0, 0, 0, 0, 36],
  [0, 0, 39, 0, 0],
  [0, 0, 0, 13, 0],
  [44, 11, 0, 0, 39],
];
const landscapeLayer3 = [
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 8, 0, 0, 0],
];

const landscape = [landscapeLayer1, landscapeLayer2, landscapeLayer3];

const map: TileSetMapType = {
  character: {
    direction: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  },
  landscape: landscape,
};

export default map;
